import SelectBox from "devextreme/ui/select_box";
import TextBox from "devextreme/ui/text_box";
import TextArea from "devextreme/ui/text_area";
import FileUploader from "devextreme/ui/file_uploader";
import { locale } from "devextreme/localization";
import CheckBox from "devextreme/ui/check_box";
import dxNumberBox from "devextreme/ui/number_box";
import config from 'devextreme/core/config';
import { licenseKey } from "../devextreme-license";

export namespace Rollout {
    export class Page {
        selectBoxInputUnit: any;
        selectBoxOutputUnit: any;
        textBoxPLZ: any
        importFileUploader: FileUploader;
        selectBoxYear: any;
        selectBoxPercentage: any;
        textAreaImport: TextArea;

        disclaimerAccepted: boolean;
        validationErrors: number;

         constructor() {
            config({ licenseKey });

            locale('de-CH');

            this.selectBoxInputUnit = new SelectBox<any>(document.getElementById('input-units-select'), {
                name: 'unit',
                items: [{ id: 0, name: "kW" }, { id: 1, name: "MW" }, { id: 2, name: "kWh" }, { id: 3, name: "MWh" }],
                displayExpr: 'name',
                valueExpr: 'id',
                value: 1,
                label: "Eingabe Einheit",
                labelMode: "floating"
            });

            this.selectBoxOutputUnit = new SelectBox<any>(document.getElementById('output-units-select'), {
                name: 'unit',
                items: [{ id: 0, name: "kW" }, { id: 1, name: "MW" }, { id: 2, name: "kWh" }, { id: 3, name: "MWh" }],
                displayExpr: 'name',
                valueExpr: 'id',
                value: 1,
                label: "Ausgabe Einheit",
                labelMode: "floating"
            });


            this.textBoxPLZ = new TextBox(document.getElementById('plz-text'), {
                name: 'plzText',
                value: "9000",
                maxLength: 5,
                label: "Postleitzahl",
                labelMode: "floating",
                onInput: async (e) => {
                    // @ts-ignore
                    let plz = e.event.target.value;
                    await this.validatePLZ(plz)
                },
            });

            this.selectBoxYear = new SelectBox<any>(document.getElementById('years-select'), {
                name: 'yearsToRollout',
                items: [1, 2, 3, 4, 5, 6],
                value: 5,
                label: "Anzahl Jahre ausrollen",
                labelMode: "floating",
                showSpinButtons: true,
            });

            this.selectBoxPercentage = new dxNumberBox(document.getElementById('percent-select'), {
                name: 'percentage',
                max: 100,
                min: 0,
                value: 100,
                label: "Prozentsatz",
                labelMode: "floating",
                showSpinButtons: true,
            });


            this.textAreaImport = new TextArea(document.getElementById('csv-textarea'), {
                name: 'csvArea',
                height: 90,
                placeholder: '...oder Lastgang per Copy-Paste hier einfügen',
                onValueChanged: async (e) => {
                    this.importFileUploader.option('value', []);
                    let res = await this.validateContent()
                    this.setValidationErrors(res)
                },
            });

            this.importFileUploader = new FileUploader(document.getElementById('file-uploader-csv'), {
                name: 'file',
                multiple: false,
                accept: '.csv',
                allowedFileExtensions: ['.csv'],
                uploadMode: 'instantly',
                labelText: "oder eine Datei ziehen",
                selectButtonText: "CSV Datei wählen",
                invalidFileExtensionMessage:"Dieser Dateitype ist nicht erlaubt. Nur *.csv!",
                invalidMaxFileSizeMessage:"Die Datei ist zu gross!",
                maxFileSize: 50000000,
                uploadFile: async () => {
                    this.textAreaImport.option('value', "");
                    let res = await this.validateContent()
                    this.setValidationErrors(res)
                }
            });

            new CheckBox(document.getElementById('disclaimer-checkbox'), {
                onValueChanged: async e => {
                    this.disclaimerAccepted = e.value;
                    let res = await this.validateContent();
                    this.setValidationErrors(res);
                }
            });
        }

        setValidationErrors(res: { validateStatus: any; messages: any; }) {
            this.validationErrors = 0
            let validationErrorsElement = document.getElementById('validationErrors');
            validationErrorsElement.innerHTML = "";
            if (res.validateStatus === 'Error') {
                let p = document.createElement("p");
                p.textContent = " Folgende Validierungsfehler sind aufgetreten: ";
                validationErrorsElement.append(p);

                res.messages.map((err: { description: string; }) => {
                    this.validationErrors++
                    let li = document.createElement("li");
                    li.textContent = err.description;
                    validationErrorsElement.append(li);
                });

                (<HTMLButtonElement>document.getElementById('uploadButtonImport')).disabled = true;
            } else {
                (<HTMLButtonElement>document.getElementById('uploadButtonImport')).disabled = false;
            }
        }


        async validatePLZ(plz: string) {
            let loadingSpan = document.getElementById("landing-page-rollout-plz-spinner")
            loadingSpan.style.display = "inline-block";
            if (plz.length !== 4) return;

            window.setTimeout(async () => {
                return fetch(`/api/mes/customer/validatePLZ?plz=${plz}`, {
                    method: "GET",
                })
                    .then(r => r.json())
                    .then(r => {
                        if (r.success) {
                            this.textBoxPLZ.option('isValid', true)
                            this.setValidationErrors({ validateStatus: 'Success', messages: [] })
                        } else {
                            this.textBoxPLZ.option('isValid', false)
                            this.setValidationErrors({ validateStatus: 'Error', messages: [{ description: 'PLZ ungültig' }] })
                        }
                    }).catch(err => {
                        console.log(err)
                    }).finally(() => {
                        loadingSpan.style.display = "none"
                    });
            }, 500);
        }

        async validateContent() {

            let unit = this.selectBoxInputUnit.option('value');
            let plz = this.textBoxPLZ.option('value');
            let file = this.importFileUploader.option('value')[0];
            let csvArea = this.textAreaImport.option('value');

            await this.validatePLZ(plz);

            if (csvArea == "" && file == null) return;


            let data = new FormData()

            data.append('EnergyUnit', unit)
            data.append('CsvArea', csvArea)
            data.append('File', file)

            return fetch("/api/mes/mesurepoints/validate", {
                method: "POST",
                body: data,
            }).then(r => r.json());
        }

        async postContent(form: HTMLFormElement) {


            let params: IRolloutRequest = {
                InputEnergyUnit: this.selectBoxInputUnit.option('value'),
                OutputEnergyUnit: this.selectBoxOutputUnit.option('value'),
                PLZ: this.textBoxPLZ.option('value'),
                YearsToRollout: this.selectBoxYear.option('value'),
                Percentage: this.selectBoxPercentage.option('value'),
                CsvArea: this.textAreaImport.option('value'),
                File: this.importFileUploader.option('value')[0]
            };


            let data = new FormData()

            for (const key in params) {
                if (Object.prototype.hasOwnProperty.call(params, key)) {
                    data.append(key, (<any>params)[key])
                }
            }

            return fetch("/api/mes/rollout/download", {
                method: "POST",
                body: data
            }).then(r => r.blob()).then(blob => {
                const url = window.URL
                    .createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                let fileName = params.File ? params.File.name : "Messpunkt";
                link.setAttribute('download', `${fileName}_Ausgerollt.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link)
            });
        }

        async submitForm() {

            let csvArea = this.textAreaImport.option('value');
            let file = this.importFileUploader.option('value');

            if (csvArea === "" && file.length <= 0) {
                let err = { validateStatus: 'Error', messages: [{ description: 'Keine Datei / Text wurde ausgewählt' }] };
                this.setValidationErrors(err);
                return;
            }

            // validate
            let res = await this.validateContent();
            this.setValidationErrors(res);

            if (this.validationErrors > 0) {
                return;
            }

            if (!this.disclaimerAccepted) {
                let err = {validateStatus: 'Error', messages: [{ description: 'Bitte akzeptieren Sie den Haftungsausschluss' }] };
                this.setValidationErrors(err);
                return;
            }

            //post
            await this.postContent(<HTMLFormElement>document.getElementById("rolloutForm"));
        }

    }

    interface IRolloutRequest {
        InputEnergyUnit: number;
        OutputEnergyUnit: number;
        PLZ: string;
        File: File;
        YearsToRollout: number;
        Percentage: number;
        CsvArea: string;
    }
}











